var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge badge-success"},[(_vm.trial.lastDay)?_c('span',[_vm._v("Last day free")]):_c('span',[_vm._v("Free for "+_vm._s(_vm.trial.daysLeft)+" day"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trial.oneDayLeft),expression:"!trial.oneDayLeft"}]},[_vm._v("s")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47f43c12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrialBadge.vue
// module id = 28ii
// module chunks = 1